import React from 'react'
import Aux from '../../../hoc/Auxiliary'
import SectionHeading from '../../../components/Heading'

export const ContentEN = props => {
    return <Aux>
        <SectionHeading priority={1} text='Payment Schemes' classes='' />

        <SectionHeading text='Plan 1 / Standard Plan' classes='' />
        <ul>
            <li>A non-refundable deposit to the amount of 2,000 EUR upon reservation of your apartment;</li>
            <li>30% of the price as a first payment, to be effected 14 days after reservation, upon signing a
preliminary contract (the deposit shall be deducted);</li>
            <li>30% of the price as a second payment, upon Act No.14 issued;</li>
            <li>30% of the price as a third payment, within two months after second payment;</li>
            <li>10% of the price as a fourth payment, upon Act No. 15 issued.</li>
        </ul>

        <SectionHeading text='Plan 2 / 2% discount from the sale price' classes='' />
        <ul>
            <li>A non-refundable deposit to the amount of 2,000 EUR upon reservation of your apartment;</li>
            <li>50% of the price as a first payment, 14 calendar days after reservation, upon signing a preliminary contract (the deposit shall be deducted);</li>
            <li>20% of the price as a second payment, upon Act No. 14;</li>
            <li>20% of the price as a third payment, within two months after second payment;</li>
            <li>10% of the price as a fourth payment, upon Act No. 15;</li>
        </ul>

        <SectionHeading text='Plan 3 / 5% discount from the sale price' classes='' />
        <ul>
            <li>A non-refundable deposit to the amount of 2,000 EUR upon reservation of your apartment;</li>
            <li>90% of the price as a first payment, 14 calendar days after reservation, upon signing a preliminary contract (the deposit shall be deducted);</li>
            <li>10% of the price as a last payment, upon Act No. 15</li>
        </ul>

        <SectionHeading text='Plan 4 / with a credit' classes='' />
        <ul>
            <li>15–20% upon signing</li>
            <li>The payments are subject to negotiations!</li>
        </ul>

        <SectionHeading text='Plan 5 / Staggered Payment' classes='' />
        <ul>
          <li>15–20% upon signing;</li>
        </ul>
        <p>The payments are subject to negotiations!</p>

        <SectionHeading text='Prices' classes='' />
        <p>Prices of apartments, VAT inclusive: from 777 EUR/sq.m.<br />
        Prices of garages, VAT incl.: from 9,600 EUR<br />
        Prices of shops, VAT incl.: negotiable</p>

        <SectionHeading text='Planned execution deadlines:' classes='' />
        <p>Act No. 14 – not later than 30.04.2019<br />
        Act No. 15 – not later than 31.05.2020</p>
    </Aux>
}

export default ContentEN



// WEBPACK FOOTER //
// ./src/routes/Payment/components/ContentEN.js